import React from 'react';
//children
import Modal, {ModalHeader, ModalBody, ModalFooter} from '../../common/Modal';

const DuplicateEntityModal = (props) => {

  return ((props.duplicateentitymodal !== undefined ?
    <Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
      <ModalHeader title={props.translations(props.duplicateentitymodal.modalTitle)} />
      <ModalBody>
        <p>{props.translations(props.duplicateentitymodal.par1)}</p>
        <table>
          <tbody>
            <tr>
              <td>{props.translations(props.duplicateentitymodal.fieldLabels1)}</td>
              <td><b>{props.registeredName}</b></td>
            </tr>
            <tr>
              <td>{props.translations(props.duplicateentitymodal.fieldLabels2)}</td>
              <td><b>{props.cof}</b></td>
            </tr>
          </tbody>
        </table>
        <p>{props.translations(props.duplicateentitymodal.message)}</p>
      </ModalBody>
      <ModalFooter>
        <button className="gdocs-btn-default" onClick={props._onAmendDetails}>{props.translations(props.duplicateentitymodal.whiteBtn)}</button>
        <button className="gdocs-btn-primary" onClick={props._onUseExisting}>{props.translations(props.duplicateentitymodal.redBtn)}</button>
      </ModalFooter>
    </Modal>
  :''));
}

export {DuplicateEntityModal};



// WEBPACK FOOTER //
// ./src/components/createAcase/Modals/index.js